import { render, staticRenderFns } from "./FulfillmentOmsAdd.vue?vue&type=template&id=21dfc59f&scoped=true&"
import script from "./FulfillmentOmsAdd.vue?vue&type=script&lang=js&"
export * from "./FulfillmentOmsAdd.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentOmsAdd.vue?vue&type=style&index=0&id=21dfc59f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dfc59f",
  null
  
)

export default component.exports